import data from "../../../../../src/FilterList.docs.json";
import * as React from 'react';
export default {
  data,
  React
};